import 'slick-carousel';

/**
 * Initialize product slider
 * @param  {String} slider - Main product slider selector
 * @param  {String} thumbs - Thumbs product slider selector
 * @return {Void}
 */

export const init = (slider = '.js-product-slider') => {
	const $slider = $(slider);
	const $arrowPrev = $slider.find('.js-product-slider-arrow-prev');
	const $arrowNext = $slider.find('.js-product-slider-arrow-next');
	const $dotsContainer = $slider.find('.js-product-slider-dots');

	const config = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		prevArrow: $arrowPrev,
		nextArrow: $arrowNext,
		appendDots: $dotsContainer,
		arrows: true,
		infinite: true,
		adaptiveHeight: true,
		centerMode: true,
		variableWidth: true,
	};

	$slider
		.find('.js-product-slider-items')
		.not('.slick-initialized')
		.slick(config);
};

init();

$(window).on('shopify:section:load', function(event) {
	init();
});
